import moment from "moment-timezone";

const TIME_ZONE = "America/New_York";

const pad = (n) => {
  return n < 10 ? "0" + n : n;
};

export const stdTimezoneOffset = function (dateObject) {
  var jan = new Date(dateObject.getFullYear(), 0, 1);
  var jul = new Date(dateObject.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

export const isDstObserved = function (dateObject) {
  return dateObject.getTimezoneOffset() < stdTimezoneOffset(dateObject);
};

export const formatPoilcyDate = (policyDate) => {
  if (policyDate) {
    var format = "MM/DD/YYYY";
    var newTime = moment(policyDate).format(format);
    return newTime;
  }
};

export const formatCalendarDate = (policyDate) => {
  if (policyDate) {
    var effDate = new Date(policyDate);
    var date = effDate.getDate();
    var month = effDate.getMonth();
    var year = effDate.getFullYear();
    return year + "-" + pad(month + 1) + "-" + pad(date);
  }
};

export const formatTimeStamp = (startDate) => {
  if (startDate) {
    let temp = startDate.split("T");
    var time = temp[1].split(":");
    return time[0] + ":" + time[1];
  }
};

// IN: 2021-06-04T09:14:34.190-0500
// OUT: 2021-06-04 9:14 AM
export const formatEstLocaleDateTime = (startDate) => {
  if (startDate) {
    const dateObject = new Date(startDate);
    const mtDate = moment(dateObject.getTime());
    const mtTime = mtDate.tz(TIME_ZONE);

    // if (mtDate.isDST()) {
    //   // mtDate.add(1, "h");
    // }

    // const timeString = dateObject.toLocaleString("en-US", {
    //   hour: "numeric",
    //   minute: "numeric",
    //   timeZone: "EST",
    //   hour12: true,
    // });
    // var dateStringUs = mtTime.format("MM/DD/YYYY");
    // const dateString = dateObject.toISOString().split("T")[0];

   
    //timeString;
    return mtTime.format("L") + " " + mtTime.format("LT");
  }
};

// IN: 2021-06-04T09:14:34.190-0500
// OUT: 07/01/2021 MM/DD/YYYY
export const formatEstLocaleDate = (startDate) => {
  if (startDate) {
    let dateString = "";
    try {
      const dateObject = new Date(startDate);
      const mtDate = moment(dateObject.getTime());
      const mtTime = mtDate.tz(TIME_ZONE);
      dateString = mtTime.format("L");
    } catch (e) {
      dateString = startDate;
    }
    return dateString;
  }
};

export const formatTimeStampAmPm = (startDate) => {};

const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];
export const selectedDateFormat = (selectedDate) => {
  if (selectedDate) {
    var date = selectedDate.getDate();
    var month = selectedDate.getMonth();
    var year = selectedDate.getFullYear();
    return pad(date) + " " + months[month] + " " + year;
  }
};

export const getConversionDate = (selectedDate) => {
  if (selectedDate) {
    var date = selectedDate.getDate();
    return pad(date);
  }
};

export const getYear = (selectedDate) => {
  if (selectedDate) {
    var year = selectedDate.getFullYear();
    return year;
  }
};

export const getMonthlyReminder = (selectedDate) => {
  if (selectedDate) {
    var month = selectedDate.getMonth();
    var year = selectedDate.getFullYear();
    return pad(month + 1) + "/" + year;
  }
};
export const setFormData = (value) => {
  if (value) {
    let standDardDate = new Date(value);
    var date = standDardDate.getDate();
    var month = standDardDate.getMonth();
    var year = standDardDate.getFullYear();
    return `${year}${pad(month + 1)}${pad(date)}`;
  }
};

export const disabledDate = () => {
  var effDate = new Date();
  var date = effDate.getDate();
  var month = effDate.getMonth();
  var year = effDate.getFullYear();
  return pad(year) + "-" + pad(month + 1) + "-" + pad(date);
};

export const formateDateTime = (dateVal) => {
  if (dateVal) {
    var newDate = new Date(dateVal);
    var sMonth = pad(newDate.getMonth() + 1);
    var sDay = pad(newDate.getDate());
    var sYear = newDate.getFullYear();
    var sHour = newDate.getHours();
    // var sAMPM = "AM";
    var iHourCheck = parseInt(sHour);
    if (iHourCheck > 12) {
      // sAMPM = "PM";
      sHour = iHourCheck - 12;
    } else if (iHourCheck === 0) {
      sHour = "12";
    }
    sHour = pad(sHour);
    let val = getDesireTime(newDate).split(":");
    let val1 = val[2].split(" ");
    let finalval = [val[0], val[1], val1[1]].join(":");
    return sMonth + "/" + sDay + "/" + sYear + " " + finalval;
  }
};
function getDesireTime(newDate) {
  if (newDate) {
    var newTime = new Date(newDate).toUTCString();
    var time = newTime.split(" ")[4];
    var hr = parseInt(time.split(":")[0]);
    // var amOrpm = hr < 12 ? "AM" : "PM"; // Set AM/PM
    hr = hr % 12 || "00"; // Adjust hours
    return `${tConvert(time)}`;
  }
}

// Convert time to 12 hours
function tConvert(time) {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? " AM" : " PM";
    time[0] = +time[0] % 12 || 12;
  }
  return time.join("");
}

export const formateWithTz = (date) => {
  var format = "YYYY-MM-DDTHH:mm:ss.ssZZ";
  var timezone = "America/New_York";
  var newTime = moment(date, format).tz(timezone).format(format);
  return newTime;
};
export const formateWithTzWithTime = (date) => {
  var format = "YYYY-MM-DDTHH:mm";
  var timezone = "America/New_York";
  var newTime = moment(date, null).tz(timezone).format(format);
  return newTime;
};

export const formateWithDayOne = (date) => {
  var format = "YYYY-MM-DDTHH:mm";
  var new_date = moment(date, format).add(1, "days");
  var timezone = "America/New_York";
  var newTime = moment(new_date._d, format).tz(timezone).format(format);
  return newTime;
};
export const formatDisplayDate = (date) => {
  var format = "MM/DD/YYYY";
  var newTime = moment(date).format(format);
  return newTime;
};
export const formateCalendarDate = (date) => {
  var format = "YYYY-MM-DDTHH:mm:ss.ssZZ";
  var new_date = moment(date, format).add(1, "days");
  var timezone = "America/New_York";
  var newTime = moment(new_date._d, format).tz(timezone).format(format);
  return newTime;
};
export const formateMaxDate = (date) => {
  var format = "MM/DD/YYYY";
  var new_date = moment(date, format).add(1, "days");
  var timezone = "America/New_York";
  var newTime = moment(new_date._d, format).tz(timezone).format(format);
  return newTime;
};
export const formatDateTimeStamp = (date) => {
  var format = "MM/DD/YYYY";
  var timezone = "America/New_York";
  var newTime = moment(date).tz(timezone).format(format);
  return newTime;
};
export const formateTimer = (date) => {
  var format = "YYYY-MM-DDTHH:mm:ss.ssZZ";
  var timezone = "America/New_York";
  var newTime = moment(date, format).tz(timezone).format(format);
  return newTime;
};
export const formateDateWidget = (date) => {
  var format = "YYYY-MM-DDTHH:mm:ss.ssZZ";
  var timezone = "America/New_York";
  var newTime = moment(date, format).tz(timezone, true).format(format);
  return newTime;
};
export const formateDateFilter = (date) => {
  var format = "YYYY-MM-DDTHH:mm:ss.ssZZ";
  var timezone = "America/New_York";
  var newTime = moment(date, format).tz(timezone, true).format(format);
  return newTime;
};

export const calculateAge = (date) => {
  let flag = false;
  var format = "YYYY-MM-DD";
  var timezone = "America/New_York";
  var c = moment(new Date(), format).tz(timezone).format(format);
  var d = moment(date, format).format(format);
  var a = moment(c);
  var b = moment(d);
  var years = a.diff(b, "year");
  b.add(years, "years");

  var months = a.diff(b, "months");
  b.add(months, "months");
  var days = a.diff(b, "days");
  if (years >= 16 && months >= 0 && days >= 0) {
    flag = false;
  } else {
    flag = true;
  }
  return flag;
};

export const checkThreeYears = (date) => {
  let flag = false;
  var format = "YYYY-MM-DD";
  var timezone = "America/New_York";
  var c = moment(new Date(), format).tz(timezone).format(format);
  var d = moment(date, format).format(format);
  var a = moment(c);
  var b = moment(d);
  var years = a.diff(b, "year");
  b.add(years, "years");

  var months = a.diff(b, "months");
  b.add(months, "months");
  var days = a.diff(b, "days");
  if (years >= 3 && months >= 0 && days >= 1) {
    flag = true;
  } else {
    flag = false;
  }
  return flag;
};

export const formatReminderDate = (policyDate) => {
  if (policyDate) {
    let date = policyDate.includes("AM")
      ? policyDate.split(" AM")
      : policyDate.split(" PM");
    var format = "MM/DD/YYYY";
    var newTime = moment(date[0]).format(format);
    return newTime;
  }
};

export const formatTimeStampReminder = (startDate) => {
  if (startDate) {
    let temp = startDate.split("T");
    var time = temp[1].split(":");
    var timeset = time[2].slice(-2);
    return time[0] + ":" + time[1] + " " + timeset;
  }
};

export const moneyDateFormat = (date) =>{
  let newDate =  moment(date).format('MM/DD/YYYY h:mm:ss A')
  return newDate
}